/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnairePossibleAnswer
 */
export interface QuestionnairePossibleAnswer {
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnairePossibleAnswer
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnairePossibleAnswer
     */
    excludeOthers: boolean;
}

/**
 * Check if a given object implements the QuestionnairePossibleAnswer interface.
 */
export function instanceOfQuestionnairePossibleAnswer(value: object): value is QuestionnairePossibleAnswer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('excludeOthers' in value) || value['excludeOthers'] === undefined) return false;
    return true;
}

export function QuestionnairePossibleAnswerFromJSON(json: any): QuestionnairePossibleAnswer {
    return QuestionnairePossibleAnswerFromJSONTyped(json, false);
}

export function QuestionnairePossibleAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnairePossibleAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': json['order'],
        'label': json['label'],
        'text': json['text'],
        'excludeOthers': json['excludeOthers'],
    };
}

export function QuestionnairePossibleAnswerToJSON(json: any): QuestionnairePossibleAnswer {
    return QuestionnairePossibleAnswerToJSONTyped(json, false);
}

export function QuestionnairePossibleAnswerToJSONTyped(value?: QuestionnairePossibleAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'order': value['order'],
        'label': value['label'],
        'text': value['text'],
        'excludeOthers': value['excludeOthers'],
    };
}

